export type BattleyeR2NewEnFlowItem =
  | {
      id: string;
      type: "text";
      role: "title" | "subtitle" | "body" | "meta";
      page: number;
      readingOrder: number;
      html: string;
      hasHighlight: boolean;
    }
  | {
      id: string;
      type: "image";
      role: string;
      page: number;
      readingOrder: number;
      src: string;
      alt: string;
    };

export const BATTLEYE_R2_NEW_EN_HERO = {
  kv: "/detail/battleye-r2-new-en/battleye_r2_new_en_p01_01.jpg",
  kvMobile: "/detail/battleye-r2-new-en/battleye_r2_new_en_p01_02.jpg",
  selling: "/detail/battleye-r2-new-en/battleye_r2_new_en_p01_03.png"
} as const;

export const BATTLEYE_R2_NEW_EN_FLOW: BattleyeR2NewEnFlowItem[] = [
  {
    id: "p02-t01",
    type: "text",
    role: "title",
    page: 2,
    readingOrder: 1,
    html: "Inspired by Metal Gear Solid 3: Snake Eater",
    hasHighlight: false
  },
  {
    id: "p02-t02",
    type: "text",
    role: "body",
    page: 2,
    readingOrder: 2,
    html: '"From loyalty to survival. From white to black."',
    hasHighlight: false
  },
  {
    id: "p02-t03",
    type: "text",
    role: "body",
    page: 2,
    readingOrder: 3,
    html:
      "True stealth hunting was never built on plastic toys. Nothing lightweight. Nothing<br />hollow. Nothing fake. Battleye R2 transforms the spirit of Snake Eater into two<br />distinct material identities.",
    hasHighlight: false
  },
  {
    id: "p02-i01",
    type: "image",
    role: "image",
    page: 2,
    readingOrder: 4,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p02_01.jpg",
    alt: "battleye_r2_new_en_p02_01"
  },
  {
    id: "p02-i02",
    type: "image",
    role: "image",
    page: 2,
    readingOrder: 5,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p02_02.png",
    alt: "battleye_r2_new_en_p02_02"
  },
  {
    id: "p02-t04",
    type: "text",
    role: "body",
    page: 2,
    readingOrder: 6,
    html: "The Damascus Aluminum Edition channels the spirit of The Boss.",
    hasHighlight: false
  },
  {
    id: "p02-t05",
    type: "text",
    role: "body",
    page: 2,
    readingOrder: 7,
    html:
      "The flowing Damascus-pattern echoes the purity of her white combat suit and the<br />silent field of lilies. Calm, disciplined, unwavering.",
    hasHighlight: false
  },
  {
    id: "p02-i03",
    type: "image",
    role: "image",
    page: 2,
    readingOrder: 8,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p02_03.jpg",
    alt: "battleye_r2_new_en_p02_03"
  },
  {
    id: "p02-i04",
    type: "image",
    role: "image",
    page: 2,
    readingOrder: 9,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p02_04.jpg",
    alt: "battleye_r2_new_en_p02_04"
  },
  {
    id: "p02-i05",
    type: "image",
    role: "image",
    page: 2,
    readingOrder: 10,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p02_05.jpg",
    alt: "battleye_r2_new_en_p02_05"
  },
  {
    id: "p02-t06",
    type: "text",
    role: "body",
    page: 2,
    readingOrder: 11,
    html: "The Carbon Silver Edition embodies Naked Snake.",
    hasHighlight: false
  },
  {
    id: "p02-t07",
    type: "text",
    role: "body",
    page: 2,
    readingOrder: 12,
    html:
      "Deep anodized black aluminum fused with forged carbon fiber and scattered silver<br />accents captures the brutal elegance of tactical survival.",
    hasHighlight: false
  },
  {
    id: "p03-i01",
    type: "image",
    role: "image",
    page: 3,
    readingOrder: 1,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p03_01.jpg",
    alt: "battleye_r2_new_en_p03_01"
  },
  {
    id: "p03-i02",
    type: "image",
    role: "image",
    page: 3,
    readingOrder: 2,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p03_02.jpg",
    alt: "battleye_r2_new_en_p03_02"
  },
  {
    id: "p03-i03",
    type: "image",
    role: "image",
    page: 3,
    readingOrder: 3,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p03_03.jpg",
    alt: "battleye_r2_new_en_p03_03"
  },
  {
    id: "p03-t01",
    type: "text",
    role: "title",
    page: 3,
    readingOrder: 4,
    html:
      '<span class="detail-inline-highlight">Triple-Chip Architecture: Uncompromising</span><br /><span class="detail-inline-highlight">Performance</span>',
    hasHighlight: true
  },
  {
    id: "p03-t02",
    type: "text",
    role: "body",
    page: 3,
    readingOrder: 5,
    html:
      '<span class="detail-inline-highlight">Built for competitive FPS titles including VALORANT, CS2, and ARC Raiders, Battleye 75HE R2 separates performance, stability, and display into three proprietary processing units to eliminate resource conflict at every level.</span>',
    hasHighlight: true
  },
  {
    id: "p03-t03",
    type: "text",
    role: "subtitle",
    page: 3,
    readingOrder: 6,
    html:
      '<span class="detail-inline-highlight">Dual-Chip Performance Core</span>',
    hasHighlight: true
  },
  {
    id: "p03-t04",
    type: "text",
    role: "body",
    page: 3,
    readingOrder: 7,
    html:
      '<span class="detail-inline-highlight">This dedicated dual-chip engine drives an esports-grade 8K Polling Rate, 256K Scan Rate, and ultra-low 0.1ms latency.</span>',
    hasHighlight: true
  },
  {
    id: "p03-t05",
    type: "text",
    role: "body",
    page: 3,
    readingOrder: 8,
    html:
      '<span class="detail-inline-highlight">Validated through daily 4-hour testing by over 80 professional esports players, this powerhouse ensures absolute Rapid Trigger stability under extreme competitive pressure.</span>',
    hasHighlight: true
  },
  {
    id: "p03-t06",
    type: "text",
    role: "subtitle",
    page: 3,
    readingOrder: 9,
    html:
      '<span class="detail-inline-highlight">Isolated Third-Chip Display Processor</span>',
    hasHighlight: true
  },
  {
    id: "p03-t07",
    type: "text",
    role: "body",
    page: 3,
    readingOrder: 10,
    html:
      '<span class="detail-inline-highlight">A standalone chip dedicated entirely to the 1.7-inch 60Hz high-res touchscreen. Independent thermals ensure zero interference, enabling real-time magnetic flux visualization and instant 0.97-second profile switching.</span>',
    hasHighlight: true
  },
  {
    id: "p03-t08",
    type: "text",
    role: "title",
    page: 3,
    readingOrder: 11,
    html:
      '<span class="detail-inline-highlight">The Community That Builds the Product</span>',
    hasHighlight: true
  },
  {
    id: "p03-t09",
    type: "text",
    role: "body",
    page: 3,
    readingOrder: 12,
    html:
      '<span class="detail-inline-highlight">JXG Esports and 61 professional Valorant &amp; Delta Force players didn’t endorse Battleye 75HE R2 — they built it.</span>',
    hasHighlight: true
  },
  {
    id: "p04-i01",
    type: "image",
    role: "image",
    page: 4,
    readingOrder: 1,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p04_01.png",
    alt: "battleye_r2_new_en_p04_01"
  },
  {
    id: "p04-i02",
    type: "image",
    role: "image",
    page: 4,
    readingOrder: 1.1,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p04_02.png",
    alt: "battleye_r2_new_en_p04_02"
  },
  {
    id: "p04-t01",
    type: "text",
    role: "body",
    page: 4,
    readingOrder: 2,
    html:
      '<span class="detail-inline-highlight">From day one of the iteration, they joined as internal testers for 7 months, providing feedback that refined keyboard width, screen responsiveness, and deadzone performance. Their real-world match training shaped every detail.</span>',
    hasHighlight: true
  },
  {
    id: "p04-t02",
    type: "text",
    role: "body",
    page: 4,
    readingOrder: 3,
    html:
      '<span class="detail-inline-highlight">This wasn’t designed in isolation — it was forged in real matches.</span>',
    hasHighlight: true
  },
  {
    id: "p04-t03",
    type: "text",
    role: "title",
    page: 4,
    readingOrder: 4,
    html: "75% Function in a Compact 60% Footprint",
    hasHighlight: false
  },
  {
    id: "p05-i01",
    type: "image",
    role: "image",
    page: 5,
    readingOrder: 1,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p05_01.png",
    alt: "battleye_r2_new_en_p05_01"
  },
  {
    id: "p05-t01",
    type: "text",
    role: "subtitle",
    page: 5,
    readingOrder: 2,
    html:
      '<span class="detail-inline-highlight">Built for muscle memory. Refined for space.</span>',
    hasHighlight: true
  },
  {
    id: "p05-t02",
    type: "text",
    role: "body",
    page: 5,
    readingOrder: 3,
    html:
      '<span class="detail-inline-highlight">Battleye 75HE R2 compresses a 75% layout into a 60% footprint, keeping the exact core gaming zone of Wooting-class boards.</span>',
    hasHighlight: true
  },
  {
    id: "p05-t03",
    type: "text",
    role: "body",
    page: 5,
    readingOrder: 4,
    html:
      "It preserves the complete F-row and essential controls while freeing up significant mouse space, creating a clear tactical zone for unrestricted movement.",
    hasHighlight: false
  },
  {
    id: "p05-t04",
    type: "text",
    role: "body",
    page: 5,
    readingOrder: 5,
    html:
      "Compared to a 60% layout, it avoids functional compromise. Compared to a traditional 75% layout, it eliminates unnecessary width that can clutter gameplay.",
    hasHighlight: false
  },
  {
    id: "p05-t05",
    type: "text",
    role: "body",
    page: 5,
    readingOrder: 6,
    html: "A layout designed for freedom, precision, and competitive clarity.",
    hasHighlight: false
  },
  {
    id: "p05-t06",
    type: "text",
    role: "title",
    page: 5,
    readingOrder: 7,
    html:
      '1.7-Inch<span class="detail-inline-highlight"> 60Hz</span> High-Res Touchscreen',
    hasHighlight: true
  },
  {
    id: "p05-t07",
    type: "text",
    role: "subtitle",
    page: 5,
    readingOrder: 8,
    html:
      '<span class="detail-inline-highlight">Instant Mode Switching. Your Screen. Your Rules.</span>',
    hasHighlight: true
  },
  {
    id: "p06-t01",
    type: "text",
    role: "body",
    page: 6,
    readingOrder: 1,
    html:
      'Continuing the widely acclaimed 1.7-inch<span class="detail-inline-highlight"> 60Hz</span> High-Resolution LCD touchscreen from the original generation.',
    hasHighlight: true
  },
  {
    id: "p06-i01",
    type: "image",
    role: "image",
    page: 6,
    readingOrder: 2,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p06_01.gif",
    alt: "battleye_r2_new_en_p06_01"
  },
  {
    id: "p06-t02",
    type: "text",
    role: "body",
    page: 6,
    readingOrder: 3,
    html:
      "Your active onboard profile, advanced key settings, RT actuation distance are all displayed clearly at a glance, giving you instant visual control without interrupting gameplay.",
    hasHighlight: false
  },
  {
    id: "p07-i01",
    type: "image",
    role: "image",
    page: 7,
    readingOrder: 1,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p07_01.jpg",
    alt: "battleye_r2_new_en_p07_01"
  },
  {
    id: "p07-t01",
    type: "text",
    role: "subtitle",
    page: 7,
    readingOrder: 2,
    html: "Switch Profiles in 0.97 Seconds",
    hasHighlight: false
  },
  {
    id: "p07-i02",
    type: "image",
    role: "image",
    page: 7,
    readingOrder: 3,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p07_02.gif",
    alt: "battleye_r2_new_en_p07_02"
  },
  {
    id: "p07-t02",
    type: "text",
    role: "body",
    page: 7,
    readingOrder: 4,
    html:
      "Battleye 75HE R2 shifts instantly between four modes: Battle, Valorant, Typing, and Custom.",
    hasHighlight: false
  },
  {
    id: "p08-t01",
    type: "text",
    role: "body",
    page: 8,
    readingOrder: 1,
    html:
      "One swipe transitions from aggressive Rapid Trigger setting to smooth typing. No complicated shortcuts, no software, no interruptions.",
    hasHighlight: false
  },
  {
    id: "p08-t02",
    type: "text",
    role: "subtitle",
    page: 8,
    readingOrder: 2,
    html:
      '<span class="detail-inline-highlight">Customizable Nameplate - Make It Unmistakably Yours</span>',
    hasHighlight: true
  },
  {
    id: "p08-t03",
    type: "text",
    role: "body",
    page: 8,
    readingOrder: 3,
    html: "More than a screen, it's your digital signature too.",
    hasHighlight: false
  },
  {
    id: "p08-t04",
    type: "text",
    role: "body",
    page: 8,
    readingOrder: 4,
    html:
      "Battleye 75HE R2 features an upgraded display chipset, unlocking a new level of personalization.",
    hasHighlight: false
  },
  {
    id: "p08-t05",
    type: "text",
    role: "body",
    page: 8,
    readingOrder: 5,
    html:
      "Rarely seen in the keyboard space, the 1.7-inch HD touchscreen transforms doubles as a digital nameplate.",
    hasHighlight: false
  },
  {
    id: "p08-t06",
    type: "text",
    role: "body",
    page: 8,
    readingOrder: 6,
    html:
      "Customize text, wallpapers, icons, and even individual key displays to reflect your setup and style.",
    hasHighlight: false
  },
  {
    id: "p08-i01",
    type: "image",
    role: "image",
    page: 8,
    readingOrder: 7,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p08_01.jpg",
    alt: "battleye_r2_new_en_p08_01"
  },
  {
    id: "p08-t07",
    type: "text",
    role: "title",
    page: 8,
    readingOrder: 8,
    html:
      '<span class="detail-inline-highlight">Carbon Fiber Plate x 6-Layer Custom Internals</span>',
    hasHighlight: true
  },
  {
    id: "p08-t08",
    type: "text",
    role: "subtitle",
    page: 8,
    readingOrder: 9,
    html:
      '<span class="detail-inline-highlight">No Harsh Bottom-Out. Tuned for Pure Comfort</span>',
    hasHighlight: true
  },
  {
    id: "p08-t09",
    type: "text",
    role: "subtitle",
    page: 8,
    readingOrder: 10,
    html: "Carbon Fiber Plate: Stability Meets Flex",
    hasHighlight: false
  },
  {
    id: "p09-t01",
    type: "text",
    role: "body",
    page: 9,
    readingOrder: 1,
    html:
      "Most magnetic keyboards rely on aluminum plates to stabilize Hall Effect sensors, often resulting in a rigid, fatiguing bottom-out feel.",
    hasHighlight: false
  },
  {
    id: "p09-t02",
    type: "text",
    role: "body",
    page: 9,
    readingOrder: 2,
    html:
      'Battleye 75HE R2 takes a different path.<span class="detail-inline-highlight"> We replaced the conventions with a single answer validated by the enthusiast community: carbon fiber plate.</span>',
    hasHighlight: true
  },
  {
    id: "p09-t03",
    type: "text",
    role: "body",
    page: 9,
    readingOrder: 3,
    html:
      '<span class="detail-inline-highlight">It locks every switch in place for absolute Rapid Trigger consistency, while its natural elasticity absorbs harsh impact during long competitive sessions.</span>',
    hasHighlight: true
  },
  {
    id: "p09-t04",
    type: "text",
    role: "body",
    page: 9,
    readingOrder: 4,
    html:
      '<span class="detail-inline-highlight">Stable like metal. Comfortable like nothing else.</span>',
    hasHighlight: true
  },
  {
    id: "p09-i01",
    type: "image",
    role: "image",
    page: 9,
    readingOrder: 5,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p09_01.jpg",
    alt: "battleye_r2_new_en_p09_01"
  },
  {
    id: "p09-i02",
    type: "image",
    role: "image",
    page: 9,
    readingOrder: 6,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p09_02.jpg",
    alt: "battleye_r2_new_en_p09_02"
  },
  {
    id: "p09-t05",
    type: "text",
    role: "subtitle",
    page: 9,
    readingOrder: 7,
    html:
      '6-Layer Custom Internals:<span class="detail-inline-highlight"> Thocky Acoustic and Typing Comfort</span>',
    hasHighlight: true
  },
  {
    id: "p09-t06",
    type: "text",
    role: "body",
    page: 9,
    readingOrder: 8,
    html:
      'Traditional<span class="detail-inline-highlight"> magnetic keyboards</span> force a trade-off between acoustics and performance, sacrificing<span class="detail-inline-highlight"> typing feel and sound for raw speed.</span>',
    hasHighlight: true
  },
  {
    id: "p09-t07",
    type: "text",
    role: "body",
    page: 9,
    readingOrder: 9,
    html:
      'Battleye 75HE R2 eliminates this trade-off, uniting elite FPS responsiveness with a thocky acoustic profile<span class="detail-inline-highlight"> and typing comfort once reserved for</span> premium custom mechanical keyboards.',
    hasHighlight: true
  },
  {
    id: "p09-t08",
    type: "text",
    role: "subtitle",
    page: 9,
    readingOrder: 10,
    html: "[BATTLEYE R2 打字音纯享版(1).mp4]",
    hasHighlight: false
  },
  {
    id: "p09-t09",
    type: "text",
    role: "body",
    page: 9,
    readingOrder: 11,
    html:
      "Six custom internal layers integrate a carbon fiber positioning plate, PCBA, and a calibrated structure of Poron foam, custom switch pads, PET film, and EPDM bottom dampening.",
    hasHighlight: false
  },
  {
    id: "p10-i01",
    type: "image",
    role: "image",
    page: 10,
    readingOrder: 1,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p10_01.jpg",
    alt: "battleye_r2_new_en_p10_01"
  },
  {
    id: "p10-t01",
    type: "text",
    role: "title",
    page: 10,
    readingOrder: 2,
    html: "Angry Miao x Wuque: Custom WS Diamond HE<br />Switches",
    hasHighlight: false
  },
  {
    id: "p10-t02",
    type: "text",
    role: "body",
    page: 10,
    readingOrder: 3,
    html:
      "A powerful collaboration with Wuque Studio. This exclusive iteration of the Diamond HE switch is engineered strictly for elite gaming performance.",
    hasHighlight: false
  },
  {
    id: "p10-t03",
    type: "text",
    role: "body",
    page: 10,
    readingOrder: 4,
    html:
      "Featuring 3.5mm total travel, 35gf actuation force, and 45gf bottom-out, this premium",
    hasHighlight: false
  },
  {
    id: "p11-t01",
    type: "text",
    role: "body",
    page: 11,
    readingOrder: 1,
    html:
      "Hall Effect switch eliminates input lag while maintaining a sharp return.",
    hasHighlight: false
  },
  {
    id: "p11-i01",
    type: "image",
    role: "image",
    page: 11,
    readingOrder: 2,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p11_01.png",
    alt: "battleye_r2_new_en_p11_01"
  },
  {
    id: "p11-t02",
    type: "text",
    role: "title",
    page: 11,
    readingOrder: 3,
    html: "Colorways",
    hasHighlight: false
  },
  {
    id: "p11-t03",
    type: "text",
    role: "subtitle",
    page: 11,
    readingOrder: 4,
    html: "Damascus",
    hasHighlight: false
  },
  {
    id: "p11-t04",
    type: "text",
    role: "body",
    page: 11,
    readingOrder: 5,
    html:
      '<span class="detail-inline-highlight">Layered aluminum alloys fused into a single billet under extreme heat, then etched to reveal a flowing Damascus pattern—unique, organic, impossible to replicate.</span>',
    hasHighlight: true
  },
  {
    id: "p12-i01",
    type: "image",
    role: "image",
    page: 12,
    readingOrder: 1,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p12_01.png",
    alt: "battleye_r2_new_en_p12_01"
  },
  {
    id: "p12-t01",
    type: "text",
    role: "body",
    page: 12,
    readingOrder: 2,
    html:
      '<span class="detail-inline-highlight">Each piece takes 10 days of forging, torsion, and chemical refinement, with a complexity that drives production costs 15× higher than standard alloys.</span>',
    hasHighlight: true
  },
  {
    id: "p12-i02",
    type: "image",
    role: "image",
    page: 12,
    readingOrder: 3,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p12_02.jpg",
    alt: "battleye_r2_new_en_p12_02"
  },
  {
    id: "p12-t02",
    type: "text",
    role: "body",
    page: 12,
    readingOrder: 4,
    html:
      '<span class="detail-inline-highlight">Not just metal—an unrepeatable fingerprint of precision engineering, capturing the raw energy of molten metal in every ripple.</span>',
    hasHighlight: true
  },
  {
    id: "p13-i01",
    type: "image",
    role: "image",
    page: 13,
    readingOrder: 1,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p13_01.jpg",
    alt: "battleye_r2_new_en_p13_01"
  },
  {
    id: "p13-t01",
    type: "text",
    role: "subtitle",
    page: 13,
    readingOrder: 2,
    html: "Carbon Silver",
    hasHighlight: false
  },
  {
    id: "p13-t02",
    type: "text",
    role: "body",
    page: 13,
    readingOrder: 3,
    html:
      "A premium composite of real carbon fiber and genuine silver, forged under high-temperature compression molding.",
    hasHighlight: false
  },
  {
    id: "p13-i02",
    type: "image",
    role: "image",
    page: 13,
    readingOrder: 4,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p13_02.jpg",
    alt: "battleye_r2_new_en_p13_02"
  },
  {
    id: "p13-t03",
    type: "text",
    role: "body",
    page: 13,
    readingOrder: 5,
    html:
      '<span class="detail-inline-highlight">Each silver flake is meticulously placed by master craftsmen with over 18 years of experience, achieving perfect visual balance and consistent material expression.</span>',
    hasHighlight: true
  },
  {
    id: "p14-i01",
    type: "image",
    role: "image",
    page: 14,
    readingOrder: 1,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p14_01.jpg",
    alt: "battleye_r2_new_en_p14_01"
  },
  {
    id: "p14-t01",
    type: "text",
    role: "body",
    page: 14,
    readingOrder: 2,
    html:
      '<span class="detail-inline-highlight">The hand-finished process demands immense time and care, making every unit inherently unique—impossible to replicate in mass production.</span>',
    hasHighlight: true
  },
  {
    id: "p14-i02",
    type: "image",
    role: "image",
    page: 14,
    readingOrder: 3,
    src: "/detail/battleye-r2-new-en/battleye_r2_new_en_p14_02.jpg",
    alt: "battleye_r2_new_en_p14_02"
  },
  {
    id: "p14-t02",
    type: "text",
    role: "title",
    page: 14,
    readingOrder: 4,
    html: "Specifications",
    hasHighlight: false
  },
  {
    id: "p15-t01",
    type: "text",
    role: "subtitle",
    page: 15,
    readingOrder: 1,
    html: "Carbon Silver (Black)<br />Damascus (White)",
    hasHighlight: false
  },
  {
    id: "p15-t02",
    type: "text",
    role: "subtitle",
    page: 15,
    readingOrder: 2,
    html: "Keyboard Body<br />Aluminum Alloy",
    hasHighlight: false
  },
  {
    id: "p15-t03",
    type: "text",
    role: "body",
    page: 15,
    readingOrder: 3,
    html: "Aluminum Alloy",
    hasHighlight: false
  },
  {
    id: "p15-t04",
    type: "text",
    role: "body",
    page: 15,
    readingOrder: 4,
    html: "Carbon fiber components<br />with pure silver accents",
    hasHighlight: false
  },
  {
    id: "p15-t05",
    type: "text",
    role: "body",
    page: 15,
    readingOrder: 5,
    html: "Damascus patterned<br />components",
    hasHighlight: false
  },
  {
    id: "p15-t06",
    type: "text",
    role: "subtitle",
    page: 15,
    readingOrder: 6,
    html: "Finish<br />Anodizing",
    hasHighlight: false
  },
  {
    id: "p15-t07",
    type: "text",
    role: "subtitle",
    page: 15,
    readingOrder: 7,
    html:
      '<span class="detail-inline-highlight">Touchscreen</span><br /><span class="detail-inline-highlight">1.7-Inch 60Hz High-Res LCD Touchscreen</span>',
    hasHighlight: true
  },
  {
    id: "p15-t08",
    type: "text",
    role: "body",
    page: 15,
    readingOrder: 8,
    html: "Instant Mode-Switching: Battle, Valorant, Typing, Custom",
    hasHighlight: false
  },
  {
    id: "p15-t09",
    type: "text",
    role: "body",
    page: 15,
    readingOrder: 9,
    html:
      "On-Screen Monitoring: Dynamic RT Actuation, HE Advanced<br />Settings, Customizable Nameplate",
    hasHighlight: false
  },
  {
    id: "p15-t10",
    type: "text",
    role: "subtitle",
    page: 15,
    readingOrder: 10,
    html:
      'RT Accuracy<br />0.001<span class="detail-inline-highlight"> mm</span>',
    hasHighlight: true
  },
  {
    id: "p15-t11",
    type: "text",
    role: "subtitle",
    page: 15,
    readingOrder: 11,
    html: "Switches<br />WS Diamond HE Switches (Angry Miao Custom Edition)",
    hasHighlight: false
  },
  {
    id: "p15-t12",
    type: "text",
    role: "subtitle",
    page: 15,
    readingOrder: 12,
    html: "Plate<br />Carbon Fiber",
    hasHighlight: false
  },
  {
    id: "p15-t13",
    type: "text",
    role: "subtitle",
    page: 15,
    readingOrder: 13,
    html: "Keycaps<br />Dark translucent PC<br />Clear translucent PC",
    hasHighlight: false
  },
  {
    id: "p15-t14",
    type: "text",
    role: "subtitle",
    page: 15,
    readingOrder: 14,
    html: "Polling Rate<br />8K",
    hasHighlight: false
  },
  {
    id: "p15-t15",
    type: "text",
    role: "subtitle",
    page: 15,
    readingOrder: 15,
    html:
      '<span class="detail-inline-highlight">Scan Rate</span><br /><span class="detail-inline-highlight">Single Key 256K, All Keys 32K</span>',
    hasHighlight: true
  },
  {
    id: "p15-t16",
    type: "text",
    role: "subtitle",
    page: 15,
    readingOrder: 16,
    html: "Latency<br />0.1 ms",
    hasHighlight: false
  },
  {
    id: "p15-t17",
    type: "text",
    role: "subtitle",
    page: 15,
    readingOrder: 17,
    html: "Connectivity<br />USB Type-C, wired-mode only",
    hasHighlight: false
  },
  {
    id: "p15-t18",
    type: "text",
    role: "subtitle",
    page: 15,
    readingOrder: 18,
    html:
      "Lighting Effects<br />Customizable in-switch RGB and under-screen lighting effects",
    hasHighlight: false
  },
  {
    id: "p15-t19",
    type: "text",
    role: "body",
    page: 15,
    readingOrder: 19,
    html:
      '<span class="detail-inline-highlight">Software</span><br /><span class="detail-inline-highlight">Driverless Web Interface (Real-time mapping / Snap Tap /</span><br /><span class="detail-inline-highlight">SOCD / Rappy Snappy / DKS / Macros)</span>',
    hasHighlight: true
  },
  {
    id: "p15-t20",
    type: "text",
    role: "title",
    page: 15,
    readingOrder: 20,
    html: "Packaging Contents",
    hasHighlight: false
  },
  {
    id: "p15-t21",
    type: "text",
    role: "body",
    page: 15,
    readingOrder: 21,
    html: "• Keyboard",
    hasHighlight: false
  },
  {
    id: "p15-t22",
    type: "text",
    role: "body",
    page: 15,
    readingOrder: 22,
    html: "• Angry Miao Sticker",
    hasHighlight: false
  },
  {
    id: "p16-t01",
    type: "text",
    role: "body",
    page: 16,
    readingOrder: 1,
    html: "• Dry Studio Sticker",
    hasHighlight: false
  },
  {
    id: "p16-t02",
    type: "text",
    role: "body",
    page: 16,
    readingOrder: 2,
    html: "• USB C to C Cable",
    hasHighlight: false
  },
  {
    id: "p16-t03",
    type: "text",
    role: "body",
    page: 16,
    readingOrder: 3,
    html: "• USB C to A Adapter",
    hasHighlight: false
  },
  {
    id: "p16-t04",
    type: "text",
    role: "body",
    page: 16,
    readingOrder: 4,
    html: "• Quick Start Guide",
    hasHighlight: false
  },
  {
    id: "p16-t05",
    type: "text",
    role: "body",
    page: 16,
    readingOrder: 5,
    html: "• 4 Additional Keycaps (W/A/S/D)",
    hasHighlight: false
  }
];
